export enum ERROR_CODES {
  APPLICATION_ALREADY_SUBMITTED = "APPLICATION_ALREADY_SUBMITTED",
  FAILED_LMS_SUBMISSION = "FAILED_LMS_SUBMISSION",
}
